import {useEffect, useMemo, useState} from "react";
import {Team, TeamAPI} from "@brg/api";
import { useChannelsContext } from "shared/contexts/ChannelsContext";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useDesignerById } from "./useDesignerById";
import { hasPersonalChannel } from "shared/helpers/teamsStatus";

export const useGetPersonalChannel = (userId: string, needRequest?: boolean) => {
    const [isFetching, setLoading] = useState(false);
    const [localChannels, setLocalChannels] = useState<Team<'Global'>[]>([]);
    const { 
        channels, 
        loading, error
    } = useChannelsContext();
    const [designer, designerLoading ]= useDesignerById(userId)

    const defaultChannelId = useMemo(() => {
        return designer?.defaultEduChannelId ?? ''
    } , [designer])

    const fetchChannels = async (params: any) => {
        setLoading(true)
        await TeamAPI.GetList({ moderationTypes: [
            ModerationType.Channel, 
            ModerationType.ChannelGroupOrCourse],
            statuses: [0, 2, 3],  
            ...params
        })
        .then((response) => {
            return response.json()
        })
        .then((response) => {
            setLoading(false)
            setLocalChannels(response?.data)
        })
    }

    useEffect(() => {
        if (needRequest && designer) {
            fetchChannels({ownerOrMemberIds: [designer?.accountId] })
        }
    } , [needRequest, designer])


      const channelsInfo = useMemo(() => {
        if (designerLoading || loading || isFetching) return null;
        const list = needRequest ? localChannels : channels;

        const defaultChannel = list?.find(({ teamId }) => teamId === defaultChannelId);
        const personalChannel = list?.find((channel) => 
            channel?.moderationType === ModerationType.Channel && 
        channel?.ownersIDs?.length === 1 && channel?.ownersIDs?.includes(designer?.accountId ?? ''))
        const anyChannel = list?.[0]

        return {
            personalChannel,
            defaultChannel, 
            autoChannel: anyChannel
        }

      } , [channels, needRequest, designerLoading, localChannels, designer, loading, defaultChannelId, isFetching])

    return {channelsInfo, isLoading: loading || isFetching, error};
}import {useEffect, useMemo, useState} from "react";
import {Team, TeamAPI} from "@brg/api";
import { useChannelsContext } from "shared/contexts/ChannelsContext";
import { ModerationType } from "shared/pages/teams/const/ModerationTypes";
import { useDesignerById } from "./useDesignerById";
import { hasPersonalChannel } from "shared/helpers/teamsStatus";

export const useGetPersonalChannel = (userId: string, needRequest?: boolean) => {
    const [isFetching, setLoading] = useState(false);
    const [localChannels, setLocalChannels] = useState<Team<'Global'>[]>([]);
    const { 
        channels, 
        loading, error
    } = useChannelsContext();
    const [designer, designerLoading ]= useDesignerById(userId)

    const defaultChannelId = useMemo(() => {
        return designer?.defaultEduChannelId ?? ''
    } , [designer])

    const fetchChannels = async (params: any) => {
        setLoading(true)
        await TeamAPI.GetList({ moderationTypes: [
            ModerationType.Channel, 
            ModerationType.ChannelGroupOrCourse],
            statuses: [0, 2, 3],  
            ...params
        })
        .then((response) => {
            return response.json()
        })
        .then((response) => {
            setLoading(false)
            setLocalChannels(response?.data)
        })
    }

    useEffect(() => {
        if (needRequest && designer) {
            fetchChannels({ownerOrMemberIds: [designer?.accountId] })
        }
    } , [needRequest, designer])


      const channelsInfo = useMemo(() => {
        if (designerLoading || loading || isFetching) return null;
        const list = needRequest ? localChannels : channels;

        const defaultChannel = list?.find(({ teamId }) => teamId === defaultChannelId);
        const personalChannel = list?.find((channel) => 
            channel?.moderationType === ModerationType.Channel && 
        channel?.ownersIDs?.length === 1 && channel?.ownersIDs?.includes(designer?.accountId ?? ''))
        const anyChannel = list?.[0]

        return {
            personalChannel,
            defaultChannel, 
            autoChannel: anyChannel
        }

      } , [channels, needRequest, designerLoading, localChannels, designer, loading, defaultChannelId, isFetching])

    return {channelsInfo, isLoading: loading || isFetching, error};
}